module.exports = __webpack_public_path__ + "img/0858-checkmark-circle-blue.61d88a42.svg";